import { render } from "./MerchantStat.vue?vue&type=template&id=3f64772f"
import script from "./MerchantStat.vue?vue&type=script&lang=js"
export * from "./MerchantStat.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__